export const LANGUAGE_MODEL = "language";

const languageModel = {
  name: "",
  languageId: "",
  level: ""
};

export default languageModel;
